// extracted by mini-css-extract-plugin
module.exports = {"container":"AmountValidation_container__1ERLA"};